import { Avatar, Badge, Box, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { selectSchool } from "../../../redux/school/schoolSlice";
import { selectRoutine } from "../../../redux/routine/routineSlice";
import { styled } from "@mui/material/styles";
import { stringAvatar, stringToColor } from "../../../features/user/avatarUtils";
import { assertThumbnailUrl } from "../../../redux/common";

const SmallAvatar = styled(Avatar)(({ theme }) => ({
  width: 20,
  height: 20,
  border: `2px solid ${theme.palette.background.paper}`,
  fontSize: "0.5rem",
}));

interface RoutinePageAvatarProps {
}

const RoutinePageAvatar = ({}: RoutinePageAvatarProps) => {
  const school = useSelector( selectSchool );
  const routine = useSelector( selectRoutine );

  return (school.selected && routine.selected) ?
    <Box sx={{ mr: 2 }}>
      <Badge
        overlap="circular"
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        badgeContent={
          <SmallAvatar alt={`${school.selected.name}`} src={`${assertThumbnailUrl(school.selected.url)}`} />
        }>
          <Avatar sx={{ backgroundColor: stringToColor(routine.selected.name) }} alt={`${routine.selected.name}`} src={`${assertThumbnailUrl(routine.selected.url)}`}>
            <Typography variant="h6" component="span">
              {stringAvatar(routine.selected.name)}
            </Typography>
          </Avatar>
      </Badge>
    </Box>
    : <></>;
};

export default RoutinePageAvatar;